import { coreApiAuthedClient } from '@/src/shared/api/clients';
import { toApiError } from '@/src/shared/api/accounts/http';
import type { Household, HouseholdInvitation, MyHouseholdResponse } from './dto';

const BASE = '/v1/households';

export async function getMyHousehold(): Promise<Household | null> {
  try {
    const res = await coreApiAuthedClient.GET<unknown, MyHouseholdResponse>({ path: `${BASE}/me` });
    return res.data.household;
  } catch (err) {
    toApiError(err);
  }
}

export async function createHousehold(): Promise<Household> {
  try {
    const res = await coreApiAuthedClient.POST<unknown, Household>({ path: BASE });
    return res.data;
  } catch (err) {
    toApiError(err);
  }
}

export async function inviteToHousehold(email: string): Promise<HouseholdInvitation> {
  try {
    const res = await coreApiAuthedClient.POST<{ email: string }, HouseholdInvitation>({
      path: `${BASE}/me/invitations`,
      data: { email },
    });
    return res.data;
  } catch (err) {
    toApiError(err);
  }
}

async function remove(path: string): Promise<void> {
  try {
    await coreApiAuthedClient.DELETE({ path });
  } catch (err) {
    toApiError(err);
  }
}

export const revokeInvitation = (id: string) =>
  remove(`${BASE}/me/invitations/${encodeURIComponent(id)}`);

export const removeMember = (userId: string) =>
  remove(`${BASE}/me/members/${encodeURIComponent(userId)}`);

export const leaveHousehold = () => remove(`${BASE}/me/membership`);

export const dissolveHousehold = () => remove(`${BASE}/me`);
